import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'youtubeEmbedSafeUrl'
})
export class YoutubeEmbedSafeUrlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value) {
    try {
      if (value) {
        const regExp = new RegExp(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);
        const code = value.match(regExp);
        return  this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + code[1]);
      }
    } catch (e) {
      return false;
    }
    return null;
  }

}
